module.exports = __webpack_public_path__ + "post-listing-hero-TnfKQ06.jpg";